import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "heart_outline_jax_975993ff79079b99b423a314bc27ff16",
  "use": "heart_outline_jax_975993ff79079b99b423a314bc27ff16-usage",
  "viewBox": "0 0 24 21",
  "content": "<symbol viewBox=\"0 0 24 21\" xmlns=\"http://www.w3.org/2000/svg\" id=\"heart_outline_jax_975993ff79079b99b423a314bc27ff16\"><path d=\"M12.084 4.81c.25-.91.71-1.77 1.424-2.483a5.628 5.628 0 0 1 7.96 7.958l-9.395 9.394-9.394-9.395a5.628 5.628 0 1 1 9.404-5.475z\" stroke-linejoin=\"round\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol